class Tabify {
    constructor(toggles, tabs, icons) {
        this.toggles = toggles
        this.tabs = tabs
        this.icons = icons
        this.toggleHandler()
    }

    toggleHandler() {
        this.toggles.forEach((toggle, i) => {
            toggle.addEventListener('click', () => {
                if (this.tabs[i].style.maxHeight) {
                    this.tabs[i].style.maxHeight = null
                    toggle.classList.remove('open')

                    if (this.icons != undefined) {
                        this.icons[i].classList.remove('open')
                    }
                } else {
                    this.tabs.forEach(tab => {
                        tab.style.maxHeight = null
                    })

                    this.toggles.forEach(toggle => {
                        toggle.classList.remove('open')
                    })

                    if (this.icons != undefined) {
                        this.icons.forEach(icon => {
                            icon.classList.remove('open')
                        })
                    }

                    this.icons[i].classList.add('open')
                    this.tabs[i].style.maxHeight = `${this.tabs[i].scrollHeight}px`
                    toggle.classList.add('open')
                }
            })
        })
    }
}

export default Tabify